import React, { useState, useEffect } from 'react'
import { Row, Col, Form, Input, Select, Button, Drawer, Alert, Modal, Switch } from 'antd'
import { saveCompany, getDataCompany, updateCompany } from 'api/Admin/company'
import ModalDelete from 'common/Management/delete'
import { toUpper } from 'lodash'
import lang from 'lang/en'
import { getCookie } from 'helper/cookie'
let wordError = ''
const DrawerCompany = (props) => {
  const {
    titleDrawer2,
    visible2,
    stateDrawer2,
    infoUser,
    setVisible2,
    dataEditCompany,
    getResultTreeCompany,
    level_ID,
    setCheckChangeTable,
    checkChangeTable,
    setCheckRenderDelete,
    parent_ID,
    permissionPage,
  } = props

  const [form] = Form.useForm()
  const token = getCookie('access_token_admin')

  //delete
  const [visibleDelete, setVisibleDelete] = useState(false)

  //check id ซ้ำ
  const [hiddenError, setHiddenError] = useState(true)

  //option
  const [dataOption, setDataOption] = useState([])
  const [dataOption2, setDataOption2] = useState([])

  //setfield
  const [companySetfield, setCompanySetfield] = useState()
  const [operationSetfield, setOperationSetfield] = useState()
  const [valueSelectCompany, setValueSelectCompany] = useState()

  //onchange
  const [onChangeCompany, setOnChangeCompany] = useState(false)

  //check bug form
  const [checkClickSave, setCheckClickSave] = useState(false)
  const language = getCookie('lang')
  const word = lang[language]

  //active status
  const [isActive, setIsActive] = useState(true)

  //check permission
  const [disablePage, setDisablePage] = useState(false)

  useEffect(() => {
    stateDrawer2 == 'edit'
      ? permissionPage.update
        ? setDisablePage(false)
        : setDisablePage(true)
      : _
  }, [visible2 == true])

  const getOptionCompany = async () => {
    await getDataCompany({
      token: token,
      level: 1,
      level_id: 0,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setDataOption([])
          return true
        }
        if (status === 200) {
          data.map((item) => {
            if (parent_ID == item.id) {
              if (language == 'en') {
                setCompanySetfield(item.code + ' ' + item.name_en)
              } else {
                setCompanySetfield(item.code + ' ' + item.name_th)
              }
            }
          })
          setDataOption(data)
        } else {
          setDataOption([])
          return true
        }
      })
      .catch((error) => {
        setDataOption([])
        console.error(error)
      })
  }

  const getOptionCompany2 = async () => {
    await getDataCompany({
      token: token,
      level: 2,
      level_id: parent_ID,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          setDataOption2([])
          return true
        }
        if (status === 200) {
          data.map((item) => {
            if (level_ID == item.id) {
              if (language == 'en') {
                setOperationSetfield(item.code + ' ' + item.name_en)
              } else {
                setOperationSetfield(item.code + ' ' + item.name_th)
              }
            }
          })

          setDataOption2(data)
        } else {
          setDataOption2([])
          return true
        }
      })
      .catch((error) => {
        setDataOption2([])
        console.error(error)
      })
  }

  useEffect(() => {
    if (token) {
      getOptionCompany()
      getOptionCompany2()
    }
  }, [checkChangeTable])

  useEffect(() => {
    if (visible2 == true) {
      setField()
    }
  }, [
    visible2,
    stateDrawer2,
    dataEditCompany,
    onChangeCompany,
    companySetfield,
    operationSetfield,
    infoUser,
  ])

  const setField = () => {
    if (stateDrawer2 === 'add') {
      setIsActive(true)
      if (onChangeCompany == false) {
        form.setFieldsValue({
          companyCode: companySetfield,
          operationCode: operationSetfield,
          localName: null,
          subOperationCode: null,
          engName: null,
          createBy: infoUser.firstname + ' ' + infoUser.lastname,
        })
      } else {
        form.setFieldsValue({
          companyCode: companySetfield,
          operationCode: null,
          localName: null,
          subOperationCode: null,
          engName: null,

          createBy: infoUser.firstname + ' ' + infoUser.lastname,
        })
      }
    } else {
      setIsActive(dataEditCompany?.status === 'Active')
      form.setFieldsValue({
        companyCode: dataEditCompany.company_code,
        operationCode: dataEditCompany.operation_code,
        subOperationCode: dataEditCompany.code,
        localName: dataEditCompany.name_th,
        engName: dataEditCompany.name_en,
        createBy: dataEditCompany.account_name,
      })
    }
  }

  const renderButton_Drawer = () => {
    const switchEl = (
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <Switch checked={isActive} onChange={setIsActive} disabled={disablePage} />
        <span>{isActive ? 'Active' : 'Inactive'}</span>
      </div>
    )

    if (checkClickSave == false) {
      if (stateDrawer2 === 'add') {
        return (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            {switchEl}
            <Button className="BTN_Next" onClick={form.submit}>
              {word['Save']}
            </Button>
          </div>
        )
      } else {
        return (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            {switchEl}
            <div>
              <Button
                className="BTN_Delete_CPF_RED"
                onClick={() => setVisibleDelete(true)}
                style={{ marginRight: 8 }}
                hidden={permissionPage.delete ? false : true}
              >
                {word['Delete']}
              </Button>
              <Button
                hidden={permissionPage.update ? false : true}
                className="BTN_Next"
                onClick={form.submit}
              >
                {word['Save']}
              </Button>
            </div>
          </div>
        )
      }
    } else {
      if (stateDrawer2 === 'add') {
        return (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            {switchEl}
            <Button className="BTN_Next" onClick={form.submit}>
              {word['Save']}
            </Button>
          </div>
        )
      } else {
        return (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            {switchEl}
            <div>
              <Button
                className="BTN_Delete_CPF_RED"
                onClick={() => setVisibleDelete(true)}
                style={{ marginRight: 8 }}
                hidden={permissionPage.delete ? false : true}
              >
                {word['Delete']}
              </Button>
              <Button
                hidden={permissionPage.update ? false : true}
                className="BTN_Next"
                onClick={form.submit}
              >
                {word['Save']}
              </Button>
            </div>
          </div>
        )
      }
    }
  }

  const onFinish = (value) => {
    setCheckClickSave(true)
    if (stateDrawer2 == 'add') {
      let a = value.companyCode.split(' ')

      let company_id
      dataOption.map((item) => {
        if (item.code == a[0]) {
          company_id = item.id
        }
      })

      let b = value.operationCode.split(' ')

      let operation_id
      let level_id = level_ID
      dataOption2.map((item) => {
        if (item.code == b[0]) {
          operation_id = item.id
          level_id = item.id
        }
      })

      const dataArray = {
        ...(company_id !== undefined ? { company_id } : {}),
        company_code: a[0],
        ...(operation_id !== undefined ? { operation_id } : {}),
        operation_code: b[0],
        code: value.subOperationCode,
        name_th: value.localName,
        name_en: value.engName,
        level: 3,
        level_id: level_id,
        status: isActive ? 'Active' : 'InActive',
      }
      try {
        saveCompany({
          params: dataArray,
          token: token,
        }).then((res) => {
          if (res.status === 200) {
            setCheckClickSave(false)
            setHiddenError(true)
            setCheckChangeTable(checkChangeTable + 1)
            getResultTreeCompany()
            SetNullForm()
            setVisible2(false)
          } else {
            if (res.data.errorCode === '2008') {
              wordError = word['err_suboperation_code']
            } else {
              wordError = 'error'
            }
            setHiddenError(false)
          }
        })
      } catch (error) {
        console.log(error)
      }
    } else {
      let a = value.companyCode.split(' ')

      let company_id
      dataOption.map((item) => {
        if (item.code == a[0]) {
          company_id = item.id
        }
      })

      let b = value.operationCode.split(' ')

      let operation_id
      let level_id = level_ID
      dataOption2.map((item) => {
        if (item.code == b[0]) {
          operation_id = item.id
          level_id = item.id
        }
      })
      const dataArray = {
        ...(company_id !== undefined ? { company_id } : {}),
        company_code: a[0],
        ...(operation_id !== undefined ? { operation_id } : {}),
        operation_code: b[0],
        code: value.subOperationCode,
        name_th: value.localName,
        name_en: value.engName,
        level: dataEditCompany.level,
        level_id: level_id,
        status: isActive ? 'Active' : 'InActive',
      }
      try {
        updateCompany({
          params: dataArray,
          token: token,
          idCompany: dataEditCompany.id,
          code: dataEditCompany.code,
        }).then((res) => {
          if (res.status === 200) {
            setCheckClickSave(false)
            setHiddenError(true)
            setCheckChangeTable(checkChangeTable + 1)
            getResultTreeCompany()
            SetNullForm()
            setVisible2(false)
          } else {
            if (res.data.errorCode === '2018') {
              wordError = word['err_suboperation_itemused']
            } else if (res.data.errorCode === '2008') {
              wordError = word['err_suboperation_code']
            } else {
              wordError = 'error'
            }
            setHiddenError(false)
          }
        })
      } catch (error) {
        console.log(error)
      }
    }
  }

  const SetNullForm = () => {
    form.setFieldsValue({
      companyCode: null,
      operationCode: null,
      localName: null,
      subOperationCode: null,
      engName: null,
      createBy: null,
    })
  }

  const onClose = () => {
    setCheckClickSave(false)
    SetNullForm()
    setHiddenError(true)
    setVisibleDelete(false)
    setVisible2(false)
    setOnChangeCompany(false)
    setIsActive(true)
  }

  const onChange = async (value) => {
    if (value) {
      let a = value.split(' ')

      let company_id
      dataOption.map((item) => {
        if (item.code == a[0]) {
          company_id = item.id
        }
      })
      setOnChangeCompany(true)
      form.setFieldsValue({
        operationCode: null,
      })
      if (company_id === undefined) {
        setDataOption2([])
        return
      }
      await getDataCompany({
        token: token,
        level: 2,
        level_id: company_id,
      })
        .then(async (response) => {
          const { status, data, error } = response

          if (error) {
            setDataOption2([])

            return true
          }
          if (status === 200) {
            setDataOption2(data)
          } else {
            setDataOption2([])

            return true
          }
        })
        .catch((error) => {
          setDataOption2([])
          console.error(error)
        })
    }
  }

  const onChangeCode = (event) => {
    form.setFieldsValue({
      subOperationCode: event.target.value.replace(/\s/g, ''),
    })
  }
  const onUpperCase = (e) => {
    form.setFieldsValue({
      subOperationCode: toUpper(e.target.value),
    })
  }
  return (
    <>
      {/* <Drawer
        maskClosable={false}
        title={<h2>{titleDrawer2}</h2>}
        placement="right"
        onClose={() => onClose()}
        destroyOnClose
        visible={visible2}
        width={'50vw'}
        bodyStyle={{ paddingBottom: 80 }}
        footer={renderButton_Drawer()}
      >
        <Form
          className="disable-page"
          form={form}
          layout="vertical"
          onFinish={onFinish}
        >
          <fieldset disabled={disablePage}>
            <div hidden={hiddenError}>
              <Alert
                style={{ marginBottom: 10 }}
                message={wordError}
                type="error"
                showIcon
              />
            </div>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  id="companyCode"
                  name="companyCode"
                  label={<h4>{word['Company_Code']}</h4>}
                  rules={[{ required: true, message: 'Please enter company code' }]}
                >
                  <Select
                    key="companyCode"
                    placeholder="Select company code"
                    size="large"
                    onChange={onChange}
                    showSearch
                    optionFilterProp="children"
                    allowClear
                    disabled={disablePage}
                  >
                    {dataOption.map((item) => (
                      <Option value={item.code}>
                        {item.code} {language == 'en' ? item.name_en : item.name_th}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  id="operationCode"
                  name="operationCode"
                  label={<h4>{word['Operation_Code']}</h4>}
                  rules={[{ required: true, message: 'Please enter operation code' }]}
                >
                  <Select
                    key="operationCode2"
                    placeholder="Select operation code"
                    size="large"
                    showSearch
                    optionFilterProp="children"
                    allowClear
                    disabled={disablePage}
                  >
                    {dataOption2 &&
                      dataOption2.map((item) => (
                        <Option value={item.code}>
                          {item.code} {language == 'en' ? item.name_en : item.name_th}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  id="subOperationCode"
                  name="subOperationCode"
                  label={<h4>{word['Sub_Operation_Code']}</h4>}
                  rules={[
                    {
                      whitespace: true,
                      required: true,
                      message: 'Please enter project type code',
                    },
                  ]}
                >
                  <Input
                    onKeyUp={onUpperCase}
                    onChange={onChangeCode}
                    size="large"
                    placeholder="Please enter project type code"
                    maxLength={10}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  id="localName"
                  name="localName"
                  label={<h4>{word['Local_Name']}</h4>}
                  rules={[
                    {
                      whitespace: true,
                      required: true,
                      message: 'Please enter local name',
                    },
                  ]}
                >
                  <Input size="large" placeholder="Please enter local name" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  id="engName"
                  name="engName"
                  label={<h4>{word['English_Name']}</h4>}
                  rules={[
                    {
                      whitespace: true,
                      required: true,
                      message: 'Please enter english name',
                    },
                  ]}
                >
                  <Input size="large" placeholder="Please enter english name" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  id="createBy"
                  name="createBy"
                  label={<h4>{word['Create_by']}</h4>}
                >
                  <Input disabled size="large" placeholder="Create By" />
                </Form.Item>
              </Col>
            </Row>
          </fieldset>
        </Form>

        <ModalDelete
          visibleDelete={visibleDelete}
          setVisibleDelete={setVisibleDelete}
          state={'sub_operation'}
          data={dataEditCompany}
          renderData={getResultTreeCompany}
          setVisibleDrawer={setVisible2}
          setCheckChangeTable={setCheckChangeTable}
          setCheckRenderDelete={setCheckRenderDelete}
        />
      </Drawer> */}
      <Modal
        maskClosable={false}
        title={<h2>{titleDrawer2}</h2>}
        placement="right"
        onCancel={() => onClose()}
        visible={visible2}
        width={'634px'}
        footer={renderButton_Drawer()}
        destroyOnClose
        className="fix-modal"
      >
        <Form className="disable-page" form={form} layout="vertical" onFinish={onFinish}>
          <fieldset disabled={disablePage}>
            <div hidden={hiddenError}>
              <Alert
                style={{ marginBottom: 10 }}
                message={wordError}
                type="error"
                showIcon
              />
            </div>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  id="companyCode"
                  name="companyCode"
                  label={<h4>{word['Business_Code']}</h4>}
                  className="customValidation"
                  rules={[{ required: true, message: 'Please enter business code' }]}
                >
                  <Select
                    key="companyCode"
                    placeholder="Select company code"
                    size="large"
                    onChange={onChange}
                    showSearch
                    optionFilterProp="children"
                    allowClear
                    disabled={disablePage}
                  >
                    {dataOption.map((item) => (
                      <Option value={item.code}>
                        {item.code} {language == 'en' ? item.name_en : item.name_th}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  id="operationCode"
                  name="operationCode"
                  label={<h4>{word['Operation_Code']}</h4>}
                  className="customValidation"
                  rules={[{ required: true, message: 'Please enter operation code' }]}
                >
                  <Select
                    key="operationCode2"
                    placeholder="Select operation code"
                    size="large"
                    showSearch
                    optionFilterProp="children"
                    allowClear
                    disabled={disablePage}
                  >
                    {dataOption2 &&
                      dataOption2.map((item) => (
                        <Option value={item.code}>
                          {item.code} {language == 'en' ? item.name_en : item.name_th}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  id="subOperationCode"
                  name="subOperationCode"
                  label={<h4>{word['Sub_Operation_Code']}</h4>}
                  className="customValidation"
                  rules={[
                    {
                      whitespace: true,
                      required: true,
                      message: 'Please enter project type code',
                    },
                  ]}
                >
                  <Input
                    onKeyUp={onUpperCase}
                    onChange={onChangeCode}
                    size="large"
                    placeholder="Please enter project type code"
                    maxLength={10}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  id="localName"
                  name="localName"
                  label={<h4>{word['Local_Name']}</h4>}
                  className="customValidation"
                  rules={[
                    {
                      whitespace: true,
                      required: true,
                      message: 'Please enter local name',
                    },
                  ]}
                >
                  <Input size="large" placeholder="Please enter local name" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  id="engName"
                  name="engName"
                  label={<h4>{word['English_Name']}</h4>}
                  rules={[
                    {
                      whitespace: true,
                      required: true,
                      message: 'Please enter english name',
                    },
                  ]}
                >
                  <Input size="large" placeholder="Please enter english name" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  id="createBy"
                  name="createBy"
                  label={<h4>{word['Create_by']}</h4>}
                >
                  <Input disabled size="large" placeholder="Create By" />
                </Form.Item>
              </Col>
            </Row>
          </fieldset>
        </Form>

        <ModalDelete
          visibleDelete={visibleDelete}
          setVisibleDelete={setVisibleDelete}
          state={'sub_operation'}
          data={dataEditCompany}
          renderData={getResultTreeCompany}
          setVisibleDrawer={setVisible2}
          setCheckChangeTable={setCheckChangeTable}
          setCheckRenderDelete={setCheckRenderDelete}
        />
      </Modal>
    </>
  )
}
export default DrawerCompany
